export default {
  // 导航列表
  nav_list: [
    {
      name: '首页',
      link: '/',
      id: 'home',
    },
    {
      name: '关于我们',
      link: '/aboutUs',
      id: 'aboutUs',
      children: [
        { name: '关于爱福纳', path: '/aboutUs' },
        { name: '检测中心', path: '/aboutUs/testingCenter' },
        { name: '新闻与资讯', path: '/aboutUs/news' },
      ],
    },
    {
      name: '产品服务',
      link: '/productService',
      id: 'productService',
      children: [
        { name: '谐波减速器', anchor: 'harmonic_drive' }, // 只需指定锚点
        { name: '关节模组', anchor: 'joint_module' },
        { name: '医疗健康解决方案', path: '/productService/medicalHealth' },
        { name: '智能工厂解决方案', path: '/productService/smartFactory' },
      ],
    },
    {
      name: '应用领域',
      link: '/applicationFields',
      id: 'applicationFields',
      children: [
        { name: '协作机器人', path: '/applicationFields' },
        { name: '人形机器人', path: '/applicationFields' },
        { name: '金属机床', path: '/applicationFields' },
        { name: '医疗器械', path: '/applicationFields' },
        { name: '轨道交通', path: '/applicationFields' },
      ],
    },
    {
      name: '联系我们',
      link: '/contactUs',
      id: 'contactUs',
      children: [
        { name: '联系方式', anchor: 'contactInfo' }, // 只需指定锚点
        { name: '在线留言', anchor: 'onlineMessage' },
      ],
    },
  ]
};



// WEBPACK FOOTER //
// ./src/store/modules/nav/locales/zh.js